var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ws-switch-component"},[_c('div',{staticClass:"ws-switch",class:_vm.checked ? 'yes':'no',on:{"click":_vm.toggleValue}},[_c('div',{staticClass:"ws-switch-knob"})]),(_vm.noLabel || _vm.yesLabel)?_c('div',{staticClass:"ws-switch-label"},[_vm._v(_vm._s(_vm.checked ? _vm.yesLabel : _vm.noLabel))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }